import { render, staticRenderFns } from "./CbsObjectsProcedure.vue?vue&type=template&id=3bc53115&scoped=true"
import script from "./CbsObjectsProcedure.vue?vue&type=script&lang=js"
export * from "./CbsObjectsProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc53115",
  null
  
)

export default component.exports